var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3637 5.05421C18.1476 4.25095 17.5142 3.61775 16.7111 3.40145C15.2439 3 9.37476 3 9.37476 3C9.37476 3 3.5059 3 2.03865 3.38625C1.25095 3.60231 0.602197 4.25109 0.386133 5.05421C0 6.52134 0 9.56402 0 9.56402C0 9.56402 0 12.622 0.386133 14.0738C0.602402 14.8769 1.23551 15.5101 2.03877 15.7264C3.52134 16.128 9.375 16.128 9.375 16.128C9.375 16.128 15.2439 16.128 16.7111 15.7417C17.5144 15.5255 18.1476 14.8924 18.3639 14.0892C18.7499 12.622 18.7499 9.57943 18.7499 9.57943C18.7499 9.57943 18.7653 6.52131 18.3637 5.05421ZM7.50615 12.3749V6.75305L12.3866 9.56396L7.50615 12.3749Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeHeader);
export default __webpack_public_path__ + "static/media/Youtube-Header.764feeb128d93d425f1c57b852c26ac8.svg";
export { ForwardRef as ReactComponent };